import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ModelSetters } from '@repo/alt/common/Utils/index.js'

export class DateSpan extends ActiveModel {
  @ActiveField({
    value: 0,
    setter: ModelSetters.emptyValuePlaceholder(0),
  })
  days: number = 0

  @ActiveField({
    value: 0,
    setter: ModelSetters.emptyValuePlaceholder(0),
  })
  hours: number = 0

  @ActiveField({
    value: 0,
    setter: ModelSetters.emptyValuePlaceholder(0),
  })
  minutes: number = 0

  @ActiveField({
    value: 0,
    setter: ModelSetters.emptyValuePlaceholder(0),
  })
  seconds: number = 0

  get formatted() {
    return this.days.toString() + '.' + [
      this.hours.toString().padStart(2, '0'),
      this.minutes.toString().padStart(2, '0'),
      this.seconds.toString().padStart(2, '0'),
    ].join(':')
  }

  set formatted(value: string) {
    const match = value.match(/^(\d+)\.(\d{2}):(\d{2}):(\d{2})$/)
    if (!match) {
      this.days = 0
      this.hours = 0
      this.minutes = 0
      this.seconds = 0

      return
    }

    this.days = match[1] ? parseInt(match[1]) : 0
    this.hours = (match[2] ? parseInt(match[2]) : 0)
    this.minutes = match[3] ? parseInt(match[3]) : 0
    this.seconds = match[4] ? parseInt(match[4]) : 0
  }

  get zero() {
    return '0.00:00:00'
  }

  get isZero() {
    return this.formatted === this.zero
  }

  static createFromFormattedString(value: string) {
    const model = this.create()
    model.formatted = value

    return model
  }
}
